import * as React from 'react';

import { SupplierTeamScreen } from '@/routes/supplier/team/team-screen';

// =============================================================================
// team-route.tsx — Adaptateur routeur de la page « Mon équipe » FOURNISSEUR (DBU §3.7, F4).
// =============================================================================
// Aucun état d'URL (vue statique : annuaire + actions). Le role-gating (§3.7 MASTER-only) est porté par
// le composant de présentation via l'identité de session (useAuth). L'ACL réelle reste côté API/RLS.

export function SupplierTeamRoute(): React.JSX.Element {
  return <SupplierTeamScreen />;
}
